import React from 'react';
import { cn } from '../lib/utils';

interface LiveStatsProps {
  className?: string;
}

const LiveStats: React.FC<LiveStatsProps> = ({ className }) => {
  const stats = [
    {
      label: 'Galaxies',
      value: '1,000+',
      color: 'text-accent-blue',
      glow: 'from-accent-blue/20 to-transparent'
    },
    {
      label: 'Daily Battles',
      value: '50K+',
      color: 'text-accent-violet',
      glow: 'from-accent-violet/20 to-transparent'
    },
    {
      label: 'Alliances',
      value: '10K+',
      color: 'text-accent-cyan',
      glow: 'from-accent-cyan/20 to-transparent'
    }
  ];

  return (
    <div className={cn('relative', className)}>
      {/* Background with starfield effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-space-purple via-space-deep to-space-void rounded-2xl overflow-hidden">
        {/* Animated stars */}
        <div className="absolute inset-0">
          {Array.from({ length: 50 }, (_, i) => (
            <div
              key={i}
              className="absolute w-0.5 h-0.5 bg-white rounded-full animate-pulse opacity-60"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${2 + Math.random() * 2}s`,
              }}
            />
          ))}
        </div>
        
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-space-void/80 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 p-8">
        <div className="flex justify-between items-end">
          {stats.map((stat, index) => (
            <div key={stat.label} className="text-center">
              {/* Stat value with glow effect */}
              <div className="relative mb-2">
                <div 
                  className={cn(
                    'text-4xl md:text-5xl font-bold tracking-tight',
                    stat.color
                  )}
                  style={{
                    textShadow: '0 0 20px currentColor',
                    filter: 'drop-shadow(0 0 10px currentColor)'
                  }}
                >
                  {stat.value}
                </div>
                
                {/* Glow background */}
                <div 
                  className={cn(
                    'absolute inset-0 blur-xl opacity-30 bg-gradient-to-r',
                    stat.glow
                  )}
                />
              </div>
              
              {/* Stat label */}
              <div className="text-white/80 text-sm font-medium tracking-wide uppercase">
                {stat.label}
              </div>
              
              {/* Connecting line */}
              {index < stats.length - 1 && (
                <div className="absolute top-1/2 right-0 w-full h-px bg-gradient-to-r from-white/20 to-transparent transform translate-x-1/2" />
              )}
            </div>
          ))}
        </div>
        
        {/* Pulse animation overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-space-star/5 via-accent-violet/5 to-accent-cyan/5 rounded-2xl animate-pulse opacity-50" />
      </div>
    </div>
  );
};

export default LiveStats;